<template>
    <div class="pop" v-if="pop.show">
        <div class="pop-detail">
            <div class="pop-title">{{pop.title}}</div>
            <div class="pop-content">{{pop.content}}</div>
            <div v-if="pop.content" class="pop-btn" @click="queryPop">我知道了</div>
            <div v-else class="pop-btn pop-btns"  @click="queryPop">
                <span>取消</span>
                <span>重选上课时间</span>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState, mapActions} from 'vuex'
    export default {
        computed: mapState({
            pop: state => state.pop
        }),
        methods: {
            ...mapActions(["updatePop"]),
            queryPop() {
                // 如果showPlus 为 true 则不执行对 scroll 的操作
                // if (!this.pop.showPlus) {
                    // this.$store.commit('isScroll', false);
                // }
               this.updatePop({
                   show: false,
                   title: '',
                   content: ''
               })
            }
        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 99999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .pop-detail {
        position: absolute;
        /* left: 1rem;
        top: 3.69rem; */
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 5.5rem;
        background-color: #FFFFFF;
        border-radius: 0.08rem;
        font-family: PingFangSC-Medium, PingFang SC;
        text-align: center;
    }
    .pop-title {
        width: 4.5rem;
        margin: 0.51rem auto 0;
        font-size: 0.32rem;
        font-weight: 500;
        color: #000000;
        /*margin-top: 0.51rem;*/
    }

    .pop-content {
        width: 4.50rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666666;
        margin: 0.29rem auto 0.82rem;
    }
    .pop-btn {
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #CD0014;
        padding: 0.28rem 0 ;
        border-top: 0.02rem solid #F0F0F0 ;
    }
    .pop-btns {
        display: flex;
        justify-content: space-around;
        padding: 0;
    }
    .pop-btns > span {
        width: 50%;
        height: 0.88rem;
        line-height: 0.88rem;
        /*padding: 0.28rem 0 ;*/
    }
    .pop-btns >span:nth-child(1) {
        color: #333333;
    }
    .pop-btns:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 0.02rem;
        height: 0.88rem;
        margin-right: -0.01rem;
        background-color: #F0F0F0;
    }

</style>



// WEBPACK FOOTER //
// src/components/diagnosisCourse/detail/pop.vue